import './SideMenu.css';
import { useLocation, NavLink } from 'react-router-dom';

export default function SideMenu(props) {

    const location = useLocation();
    return (
        <div className="side-panel">
        <ul className="side-panel-menu-items">
                {props.menuItems.filter(m => m[props.lang]).map((m, ix) => (
                    <NavLink 
                        to={props.pathPrefix + m.path + location.search} 
                        activeClassName="side-panel-menu-item-active" 
                        className="side-panel-menu-item"
                        isActive={() => m.path === props.selectedMenuItem}
                        key={ix}>
                            {m[props.lang]}
                    </NavLink>
                ))}
        </ul>
    </div>);
}
